import React from "react";

// ICONS
import Icon from "../icons/Icon";
import { injectIntl } from "react-intl";

const MobToggleMenuBtn = ({ toggle, iconID, clicked, intl }) => {
  const handleClick = () => {
    clicked();
  };

  return (
    <button
      onClick={handleClick}
      className="__mb bc12"
      aria-label={intl.formatMessage({ id: "toggleMenu" })}
    >
      {toggle ? <Icon iconId="x" /> : <Icon iconId={iconID} />}
    </button>
  );
};

export default injectIntl(MobToggleMenuBtn);
